import React from 'react';
import QuickFiltersDropdown from 'components/BuildableFilter/QuickFilters/QuickFiltersDropdown';
import {
  applyFilters,
  removeFilters,
  areFiltersApplied,
  getQuickFilterValues,
} from 'components/BuildableFilter/QuickFilters/service';
import { useGetRequest } from 'services/gecko-request';

const SkillsTableQuickFilters = ({ botId, filters, onChange }) => {
  const [tags, areTagsLoading] = useGetRequest(
    `/bots/${botId}/skills/used-tags`
  );

  const getOptions = () => {
    if (!tags) return [];
    return tags.map((tag) => {
      return {
        label: tag.name,
        value: [
          {
            key: 'bot_tag_ids',
            operator: 'textarray:is',
            value: [tag.id],
          },
        ],
      };
    });
  };

  const quickFilters = [
    {
      label: 'By Tag',
      options: getOptions(),
    },
  ];

  const onFilterSelect = (newFilters) => {
    if (areFiltersApplied(newFilters, filters)) {
      return onChange(removeFilters(newFilters, filters));
    }
    const allQuickFilters = getQuickFilterValues(quickFilters);
    const withoutQuickFilters = allQuickFilters.reduce(
      (filters, quickFilter) => {
        return removeFilters(quickFilter, filters);
      },
      filters
    );
    onChange(applyFilters(newFilters, withoutQuickFilters));
  };

  return (
    <QuickFiltersDropdown
      isLoading={areTagsLoading}
      disabled={areTagsLoading || !tags.length}
      filters={filters}
      quickFilters={quickFilters}
      onFilterSelect={onFilterSelect}
    />
  );
};

export default SkillsTableQuickFilters;
